/**
 * Fantasy Console 0 - Editor Type Definitions
 */

export type TabId = 'code' | 'sprites' | 'map' | 'sound' | 'library' | 'play'

export type ViewId = 'editor' | 'library' | 'play'

export type EditorTabId = 'code' | 'sprites' | 'map' | 'sound'

export interface Tab {
  id: TabId
  label: string
  shortcut: string
}

export const TABS: Tab[] = [
  { id: 'code', label: 'Code', shortcut: '1' },
  { id: 'sprites', label: 'Sprites', shortcut: '2' },
  { id: 'map', label: 'Map', shortcut: '3' },
  { id: 'sound', label: 'Sound', shortcut: '4' },
  { id: 'library', label: 'Library', shortcut: '5' },
  { id: 'play', label: 'Play', shortcut: '6' },
]

export const EDITOR_TABS: Tab[] = TABS.slice(0, 4)

export function getViewForTab(tab: TabId): ViewId {
  if (tab === 'library') return 'library'
  if (tab === 'play') return 'play'
  return 'editor'
}

export function isEditorTab(tab: TabId): tab is EditorTabId {
  return tab === 'code' || tab === 'sprites' || tab === 'map' || tab === 'sound'
}

export type ToastType = 'success' | 'error' | 'warning' | 'info'

export interface Toast {
  id: string
  type: ToastType
  message: string
  duration?: number
}

export type ConsoleStatus = 'loading' | 'ready' | 'running' | 'paused' | 'error'
